import { Component } from '@angular/core';

@Component({
  selector: 'lib-disclaimer-content-ignite',
  templateUrl: 'disclaimer-content-ignite.component.html',
  styleUrls: ['disclaimer-content-ignite.component.scss'],
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class DisclaimerContentIgniteComponent {

}
